import Vue from 'vue'
import Router from 'vue-router'
import hoofdscherm from '@/components/hoofdscherm'
Vue.use(Router)

export default new Router({
  routes:[
    {
      path:"/",
      name:"5A",
      component:hoofdscherm,
      props:{klas:"5A"}
    },
    {
      path:"/5A",
      name:"5A_",
      component:hoofdscherm,
      props:{klas:"5A"}
    },
    {
      path:"/5B",
      name:"5B",
      component:hoofdscherm,
      props:{klas:"5B"}
    },
    {
      path:"/5C",
      name:"5C",
      component:hoofdscherm,
      props:{klas:"5C"}
    },
     {
      path: "/Woumen",
      name: "Woumen",
      component: hoofdscherm,
      props: { klas: "Woumen" }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js